module.exports = __webpack_public_path__ + "img/xcl.35808735.png";